import React from 'react';
import EmailsTable from './table-section/table';

export default function EmailsTab() {
  return <EmailsTable />;
}
